// extracted by mini-css-extract-plugin
module.exports = {"hero":"page--hero--2kkle","page":"page--page--30zjZ","ghostRelatedArticlesCarousel":"page--ghostRelatedArticlesCarousel--21oI7","disclaimerText":"page--disclaimerText--1LIEN"};